export const TestIds = {
  topBar: {
    loginsection: 'ces-top-bar-login-section',
    menuItem: 'ces-top-bar-menu-item',
    datepicker: 'ces-top-bar-date-picker',
    usercounter: 'ces-top-bar-user-counter',
    filter: 'ces-top-bar-filter',
  },
};
